import { Table } from '@tanstack/react-table'
import { OpenedTable } from '.'
import { utils, writeFile } from 'xlsx'
import { Opened } from '@/types/BankStatement'
import { getDateFromId } from '@/utils/date'
  
export const useOpenedSpreadsheets = () => {
    const getTableRows = (table: Table<OpenedTable>): Partial<Opened>[] =>
        table.getCoreRowModel().rows.map((row) => {
            const obj = {} as Record<string, any>
 

            obj['Revenda'] = row.original.DS_ROTA
            obj['Cod. Rota'] = row.original.DD_ROTA
            obj['Empresa'] = row.original.ABREVIATURA_EMPRESA
            obj['Num. Documento'] = row.original.DD_NUMERO_DOCUMENTO
            obj['Dt. Emissão'] = getDateFromId(Number(row.original.SK_EMISSAO))
            obj['Dt. Vencimento'] = getDateFromId(Number(row.original.SK_VENCIMENTO_REAL))
            obj['Dias Juros'] = row.original.DD_DIAS_JUROS
            obj['Valor a Vencer'] = Number(row.original.VL_A_VENCER)
            obj['Vl. Vencido'] = Number(row.original.VL_VENCIDO)
            obj['Vl. Juros'] = Number(row.original.VL_JUROS_PELO_PRAZO)
            obj['Vl. Multa'] = Number(row.original.VL_MULTA)
            obj['ID Carga'] = row.original.DD_IDCARGA

            return obj
        })

    const onDownload = (tableInstance: Table<OpenedTable>) => {
         
        const rows = getTableRows(tableInstance)
        const colluns = Object.keys(rows[0]).length;

        const formatDate = 'dd/mm/yyyy'
        const formatMoneyAccounting = '_-* #,##0.00_-;-* #,##0.00_-;_-* "-"??_-;_-@_-'

        const worksheet = utils.aoa_to_sheet([[]]);
         
        worksheet['G1'] =  { t: 's', v: 'Totais: ' }
        worksheet['H1'] =  { t: 'n', f: `SUBTOTAL(9, H3:H${rows.length + 3})`, z: formatMoneyAccounting }
        worksheet['I1'] =  { t: 'n', f: `SUBTOTAL(9, I3:I${rows.length + 3})`, z: formatMoneyAccounting }
        worksheet['J1'] =  { t: 'n', f: `SUBTOTAL(9, J3:J${rows.length + 3})`, z: formatMoneyAccounting }
        worksheet['K1'] =  { t: 'n', f: `SUBTOTAL(9, K3:K${rows.length + 3})`, z: formatMoneyAccounting } 
        
        utils.sheet_add_json(worksheet, rows, {
            origin: { r: 1, c: 0 } 
        });

        for (let i = 3; i <= rows.length + 2; i++) { 
            
            worksheet[`E${i}`].z = formatDate
            worksheet[`F${i}`].z = formatDate 
            
            worksheet[`G${i}`].z = '#,##0'
            worksheet[`G${i}`].t = 'n'
            worksheet[`H${i}`].z = formatMoneyAccounting
            worksheet[`I${i}`].z = formatMoneyAccounting
            worksheet[`J${i}`].z = formatMoneyAccounting
            worksheet[`K${i}`].z = formatMoneyAccounting 
        }

        worksheet["!cols"] =  Array(colluns).fill({ wch: 20 });

        const workbook = utils.book_new()

        utils.book_append_sheet(workbook, worksheet, 'Titulos')

        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const year = currentDate.getFullYear().toString();
        const currentDateFormated =  day + month + year;

        writeFile(workbook, `Extrato_Revenda_Em_Aberto_${currentDateFormated}.xlsx`, {
            compression: true,
        })
    }

    return {
        onDownload,
    }
}
